// Engine API: seity bond commitment (V0).
// Backed by ~/Dev/seitiate/app/api/v1/seity_bond.py.
//
// V0 (SEITY-BOND-COMMITMENT-V0, 2026-05-15): a human accepts responsibility
// for their agent's actions. No cryptographic credential is generated — that
// lands in V1 once Pavel's Elixir substrate is ready.

import { engineFetchJson } from '@/lib/engineHttp';

export interface CommitSeityBondRequest {
  seity_name: string;
  vows_text: string;
  seity_handle?: string;
  identity_verification?: string;
}

export interface CommitSeityBondResponse {
  bond_db_id: string;
  bond_id: string;
  seity_id: string;
  user_id: string;
  tenant_id: string;
  status: string;
  seity_name: string;
  vows_text: string;
}

/** POST /api/v1/seity-bond/commit — write the responsibility bond row. */
export async function commitSeityBond(
  body: CommitSeityBondRequest,
): Promise<CommitSeityBondResponse> {
  return engineFetchJson<CommitSeityBondResponse>('/seity-bond/commit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}
